import { createSlice } from '@reduxjs/toolkit';
import authService from 'services/auth.service';
import { apiSlice } from './api.slice';
import { appError } from './app.slice';

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState: {
    jobs: [],
    jobData: {},
    fullData: [],
    screens: [],
    jobPage: {
      count: 0,
      currentPage: 1,
      lastPage: 1,
      nextPage: null,
      prevPage: null,
    },
    jobPgBtn: {
      page: 1,
      take: 50,
      query: '',
      closed: false,
      open: false,
      quickJobs: false,
      job_assigned: false,
      job_ads: false,
    },
    jobCareersPgBtn: {
      take: 50,
      page: 1,
      work_type_id: null, //to make it remote make value to 1
      query: '',
      specification_id: null,
    },
  },
  reducers: {
    listJobs: (state, { payload }) => ({ ...state, ...payload }),
    getJob: (state, { payload }) => ({ ...state, ...payload }),
  },
});

export const { listJobs, getJob } = jobsSlice.actions;
export default jobsSlice.reducer;

/* ----------------------------------- API ---------------------------------- */
export const jobsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    ListJobs: builder.mutation({
      query: (data) => ({
        url: '/jobs',
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(listJobs({ jobs: data.data.data }));
          dispatch(
            listJobs({
              jobPage: {
                count: data.data.count,
                currentPage: data.data.currentPage,
                lastPage: data.data.lastPage,
                nextPage: data.data.nextPage,
                prevPage: data.data.nextPage,
              },
            })
          );
        } catch ({ error }) {
          dispatch(appError(error));
          authService.logout();
        }
      },
    }),
    CreateJobs: builder.mutation({
      query: (data) => ({
        url: '/jobs/create',
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    UpdateJobs: builder.mutation({
      query: ({ data, id }) => ({
        url: `/jobs/update/${id}`,
        method: 'PUT',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(getJob({ jobData: { ...data.data, ...data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    CreateQuick: builder.mutation({
      query: (data) => ({
        url: '/jobs/quick',
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    UpdateQuick: builder.mutation({
      query: ({ data, id }) => ({
        url: `/jobs/update-quick/${id}`,
        method: 'PUT',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(getJob({ jobData: { ...data.data, ...data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    GetJobs: builder.mutation({
      query: ({ id }) => ({
        url: `/jobs/view/${id}`,
        method: 'GET',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(getJob({ jobData: { ...data.data, ...data.data.data } }));
          dispatch(getJob({ fullData: { ...data.data, ...data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    DeleteJobs: builder.mutation({
      query: ({ id }) => ({
        url: `/jobs/delete/${id}`,
        method: 'DELETE',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    CreateQuestionJobs: builder.mutation({
      query: ({ data, id }) => ({
        url: `/screen-question/create/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          // const { data } = await queryFulfilled;
          // dispatch(getJob({ jobData: { ...data.data, questions: data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    UpdateQuestionJobs: builder.mutation({
      query: ({ data, id }) => ({
        url: `/screen-question/update/${id}`,
        method: 'PUT',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          // const { data } = await queryFulfilled;
          // dispatch(getJob({ jobData: { ...data.data, questions: data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    DeleteQuestionJobs: builder.mutation({
      query: ({ id }) => ({
        url: `/screen-question/delete/${id}`,
        method: 'DELETE',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          // const { data } = await queryFulfilled;
          // dispatch(getJob({ jobData: { ...data.data, questions: data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    ListQuestionJobs: builder.mutation({
      query: ({ data, id }) => ({
        url: `/screen-question/job/${id}`,
        method: 'GET',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(getJob({ screens: { ...data.data, questions: data.data } }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    CreateJobAds: builder.mutation({
      query: ({ data, id }) => ({
        url: `/job-ads/create/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    ListClientJobs: builder.mutation({
      query: ({ data, id }) => ({
        url: `/jobs/client/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(listJobs({ jobs: data.data.data }));
          dispatch(
            listJobs({
              jobPage: {
                count: data.data.count,
                currentPage: data.data.currentPage,
                lastPage: data.data.lastPage,
                nextPage: data.data.nextPage,
                prevPage: data.data.nextPage,
              },
            })
          );
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    ListLeadJobs: builder.mutation({
      query: ({ data, id }) => ({
        url: `/jobs/lead/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(listJobs({ jobs: data.data.data }));
          dispatch(
            listJobs({
              jobPage: {
                count: data.data.count,
                currentPage: data.data.currentPage,
                lastPage: data.data.lastPage,
                nextPage: data.data.nextPage,
                prevPage: data.data.nextPage,
              },
            })
          );
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    UpdateJobAds: builder.mutation({
      query: ({ data, id }) => ({
        url: `/job-ads/update/${id}`,
        method: 'PUT',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    DeleteJobAds: builder.mutation({
      query: ({ id }) => ({
        url: `/job-ads/delete/${id}`,
        method: 'DELETE',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    toggleStatus: builder.mutation({
      query: ({ id }) => ({
        url: `/jobs/active-toggle/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    CreateRecruiters: builder.mutation({
      query: ({ data, id }) => ({
        url: `/jobs/recruiters/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    UpdateRecruiters: builder.mutation({
      query: ({ data, id }) => ({
        url: `/recruiters/update/${id}`,
        method: 'PUT',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    DeleteRecruiters: builder.mutation({
      query: ({ data, id }) => ({
        url: `/recruiters/delete/${id}`,
        method: 'DELETE',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    toggleAdsStatus: builder.mutation({
      query: ({ id }) => ({
        url: `/job-ads/active-toggle/${id}`,
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    SubmitFile: builder.mutation({
      query: (data) => ({
        url: '/careers/resume/upload',
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    SubmitApplication: builder.mutation({
      query: (data) => ({
        url: '/careers/submit',
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
    ListCareers: builder.mutation({
      query: (data) => ({
        url: '/careers/ads',
        method: 'POST',
        credentials: 'include',
        withCredentials: true,
        crossorigin: true,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: data,
      }),
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(listJobs({ jobs: data.data.data }));
        } catch ({ error }) {
          dispatch(appError(error));
        }
      },
    }),
  }),
});

export const {
  useListJobsMutation,
  useCreateJobsMutation,
  useUpdateJobsMutation,
  useCreateQuickMutation,
  useUpdateQuickMutation,
  useGetJobsMutation,
  useDeleteJobsMutation,
  useCreateQuestionJobsMutation,
  useUpdateQuestionJobsMutation,
  useDeleteQuestionJobsMutation,
  useCreateJobAdsMutation,
  useListClientJobsMutation,
  useUpdateJobAdsMutation,
  useDeleteJobAdsMutation,
  useToggleStatusMutation,
  useCreateRecruitersMutation,
  useUpdateRecruitersMutation,
  useDeleteRecruitersMutation,
  useToggleAdsStatusMutation,
  useListQuestionJobsMutation,
  useListLeadJobsMutation,
  useSubmitFileMutation,
  useSubmitApplicationMutation,
  useListCareersMutation,
} = jobsApiSlice;
